import { useTheme } from 'next-themes';
import { type ReactNode } from 'react';

import dotBgDark from './assets/dot-bg.dark.png';
import dotBgLight from './assets/dot-bg.light.png';
import * as styles from './index.css';

export const AffineOtherPageLayout = ({
  children,
}: {
  children: ReactNode;
}) => {
  const { resolvedTheme } = useTheme();
  const backgroundImage =
    resolvedTheme === 'dark' && dotBgDark ? dotBgDark : dotBgLight;

  return (
    <div
      className={styles.root}
      style={{ backgroundImage: `url(${backgroundImage})` }}
    >
      {/*
        Pabbly MindMap build: the auth pages no longer carry AFFiNE's top nav
        (logo linking to affine.pro, Official website / Blog / Contact us) nor
        the "Download app" promo — this is an internal tool, not a product page.
      */}
      {BUILD_CONFIG.isElectron ? (
        <div className={styles.draggableHeader} />
      ) : (
        <div className={styles.topNav} />
      )}

      {children}
    </div>
  );
};
